import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { List } from 'immutable';
import { BaseEntity, BaseInlineContainer, InlineContainerService, UserService } from 'yt-ng-framework';

@Component({
  selector: 'yt-useripadress-update-container',
  templateUrl: './useripadress-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})
export class UseripadressUpdateContinerComponent  <T extends BaseEntity> 
extends BaseInlineContainer<T> {

  constructor(
    inlineContainerService: InlineContainerService<T>,
    activatedRoute: ActivatedRoute,
    userService: UserService
  ) { 
    super(inlineContainerService, activatedRoute, userService)
  }

  @ViewChild('baseDetailList', { static: true }) baseDetailList: any;

  tempItems: List<T>
  setItems(items){
    this.tempItems = items;
  }

  Refresh(){
    this.baseDetailList.RefreshData();
  }

}
